export const DIPLOME_DATA = [
  { value: "CEPE", label: "CEPE" },
  { value: "BEPC", label: "BEPC" },
  { value: "Bacc Litéraire", label: "Bacc Litéraire" },
  { value: "Bacc Scientifique", label: "Bacc Scientifique" },
  { value: "Bacc Gestion/Economie", label: "Bacc Gestion/Economie" },
  { value: "Bacc Technique", label: "Bacc Technique" },
  { value: "Bacc+2-DTS", label: "Bacc+2-DTS" },
  { value: "Bacc+3-Licence", label: "Bacc+3-Licence" },
  { value: "Bacc+4-Master I", label: "Bacc+4-Maitrise" },
  { value: "Bacc+5-Master II", label: "Bacc+5-Master II/Ingénieur" },
  { value: "DEA", label: "DEA" },
  { value: "AEA", label: "AEA" },
  { value: "Doctorat", label: "Doctorat" },
];

// export const EXCLUDED_DIPLOME_CONSULTANT_INDIV : ["CEPE", "BEPC"];

export const FILIERE_DATA = [
  { value: "agronomie", label: "AGRONOMIE" },
  { value: "Génie rural", label: "GENIE RURAL" },
  { value: "économie rurale", label: "ECONOMIE RURALE" },
  { value: "agribusiness", label: "AGRIBUSINESS" },
  {
    value: "Sciences sociales",
    label: "SCIENCES SOCIALES",
  },
  { value: "Sciences et technologies", label: " Sciences et technologies" },
  { value: "Arts et lettres", label: " Arts et lettres" },
  {
    value: "Santé et sciences de la vie",
    label: "Santé et sciences de la vie",
  },
  { value: "Commerce et gestion", label: "Commerce et gestion" },
  {
    value: "Environnement et développement durable",
    label: " Environnement et développement durable",
  },
  {
    value: "Industrie pétrolière et gazière",
    label: "Industrie pétrolière et gazière",
  },
  { value: "Géologie et géosciences", label: "Géologie et géosciences" },
  { value: "Elevages et agriculture", label: "Elevages et agriculture" },
  { value: "Géographie", label: "Géographie" },
  { value: "Gestion", label: "Gestion" },
  { value: "Economie", label: "Economie" },
  { value: "Sociologie", label: "Sociologie" },
  { value: "Sciences sociales", label: "Sciences sociales" },
  {
    value: "Science de la terre et environnement",
    label: "Science de la terre et environnement",
  },
  // { value: "Autres", label: "Autres" },
];

export const INCLUDED_CI_FILIERE = [
  { value: "AGRONOMIE", label: "AGRONOMIE" },
  { value: "GENIE RURAL", label: "GENIE RURAL" },
  { value: "ECONOMIE RURALE", label: "ECONOMIE RURALE" },
  { value: "AGRIBUSINESS", label: "AGRIBUSINESS" },
  {
    value: "SCIENCES SOCIALES",
    label: "SCIENCES SOCIALES",
  },
  { value: "Elevages et agriculture", label: "Elevages et agriculture" },
  { value: "Génie rural", label: "Génie rural" },
  { value: "Géographie", label: "Géographie" },
  { value: "Gestion", label: "Gestion" },
  { value: "Economie", label: "Economie" },
  { value: "Sociologie", label: "Sociologie" },
  { value: "Sciences sociales", label: "Sciences sociales" },
  {
    value: "Science de la terre et environnement",
    label: "Science de la terre et environnement",
  },
  { value: "Autres", label: "Autres" },
];

export const INCLUDED_CI_DOMAINE = [
  "Agribusiness",
  "Economie rurale",
];
export const INCLUDED_CI_SOUS_DOMAINE = [
  "Développement local",
  "Socio organisation",
  "Mobilisation sociale",
  "Communication",
  "Formation",
  "Conduite de chantier HIMO",
];

export const TYPE_STAGE = [
  "Stage de fin d’études / validation de mémoire",
  "Stage d’imprégnation",
  "Stage volontaire",
];

export const LOCALISATION_DATA = [
   { id: 1, localisation: "LOT 1 " },
   { id: 2, localisation: "LOT 2 " },
   { id: 3, localisation: "LOT 3 " },
]